import $ from 'jQuery';
import SVG from 'svg.js';
global.$ = global.jQuery = $;

var $window = $(window);
var $body = $("body");
var $nav = $("#nav");
var $navBtn = $("#nav_oc");
var $navBtns = $("#nav_btns");
var $top = $("#top");


var $lineBG = $(".line-bg");
var __lineCount;
var setLineBackground = function(){
  //console.log('setLineBackground');
  var __count;
  var __windowWidth = $window.width();
  if(__windowWidth < 1188){
    __count = 5;
  }else{
    __count = ((__windowWidth / 297) | 0) + 1;
  }
  if(__lineCount !== __count){
    __lineCount = __count;
    $lineBG.empty();
    for(var _i = 1; _i <= __lineCount; _i++){
      $lineBG.append('<div class="linebg linebg' + _i + '"></div>');
    }
  }
};
setLineBackground();

var NavOpenClose = function(){
  if($nav.hasClass("nav--sp")){
    $nav.removeClass("nav--open");
    $navBtn.removeClass("nav--oc-open");
  }
};

var ScrollToTarget = function(event){
  var __$target = $(event.currentTarget);
  var __targetHash = __$target.attr("href");
  if(__targetHash === "" || __targetHash.indexOf("#") !== 0){
    return false;
  }
  var __targetOffsetTop = $(__targetHash).offset().top;
  $("html, body").stop().animate({scrollTop: __targetOffsetTop},400);
  NavOpenClose();
  return false;
};
$(".btn--anchor").on("click", ScrollToTarget);
$("#pagetop").on("click", function(){
  $("html, body").stop().animate({scrollTop: 0},400);
});

var allAppearFrag = false;
global.setAnimation = function(){
  var $section = $(".animate-section");
  var sectionLen = $section.length;
  var timing;
  if($window.width() < 750){
    timing = $window.height() - 100;
  }else{
    timing = $window.height() - ($window.height() / 2);
  }
  for(var i = 0; i < sectionLen; i++){
    var $target = $($section[i]);
    var offsetTop = $target.offset().top;
    if(offsetTop >= $window.scrollTop() && $window.scrollTop() + timing >= offsetTop){
      var $wait = $target.find(".wait");
      var _time = 0;

      var _timer = setTimeout(function(){
        $wait.each(function(n){
          var _$this = $($wait[n]);
          var _dely = 0;
          var _mount = n * _dely;

          if(_$this.hasClass("mvblue")){
            _mount = 300;
          }
          if(_$this.hasClass("mvblue") && _$this.hasClass("mv--btn")){
            _mount = 500;
          }

          if(_$this.hasClass("message-imgs") || _$this.hasClass("originality--btn")){
            _mount = 200;
          }

          if(_$this.hasClass("people-work--btn")){
            _mount = 400;
          }


          _$this.delay(_mount).queue(function(){
            var __$this = $(this);
            if(__$this.hasClass("slide")){
              __$this.removeClass("wait").addClass('slide-move');
              if(__$this.hasClass("slide")){
                var _timeout = setTimeout(function(){
                  __$this.removeClass("slide slide-move");
                  clearTimeout(_timeout);
                }, 1200);
              }
            }else{
              __$this.removeClass("wait").addClass('animation');
            }
          });
        });
        clearTimeout(_timer);
      }, _time);

      if($(".wait").length === 0){
        allAppearFrag = true;
        $window.off("scroll", AnimationScroller);
      }
    }
  }
};

var appearSPNavigation = function(){
  if($nav.hasClass("nav--open") || $nav.hasClass("nav--oc-open")){
    $nav.removeClass("nav--open");
    $navBtn.removeClass("nav--oc-open");
    $body.removeClass("is-modal");
    $navBtn.css({marginRight: ""});
    $navBtns.css({marginRight: ""});
  }else{
    $nav.addClass("nav--open");
    $navBtn.addClass("nav--oc-open");
    $body.addClass("is-modal");
    $navBtn.css({marginRight: $window.width() - $nav.width()});
    $navBtns.css({marginRight: $window.width() - $nav.width()});
  }
};

$navBtn.on("click", appearSPNavigation);

var Scroller = function(){};

var AnimationScroller = function(){
  setAnimation();
};


$window.on("scroll", Scroller);
$window.on("scroll", AnimationScroller);
Scroller();
AnimationScroller();

global._isSP = false;
var Resize = function(event){
  setLineBackground();
  if($window.width() < 750){
    if(!_isSP){
      _isSP = true;
      if($nav.hasClass("nav--open")){
        //$nav.removeClass("nav--open")
      }
    }
    if($nav.hasClass("nav--pc")){
      $nav.removeClass("nav--pc");
      $nav.addClass("nav--sp");
    }
  }else{
    if(_isSP){
      _isSP = false;
    }
    if($nav.hasClass("nav--sp")){
      $nav.removeClass("nav--sp");
      $nav.addClass("nav--pc");
    }
  }
};

//console.log('set Resize');
$window.on("resize", Resize);
Resize();

if($window.width() < 750){
  $nav.addClass("nav--sp");
}else{
  $nav.addClass("nav--pc");
}
$("body").removeClass("init");

